import { Action, Selector, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import { FunctionalityState } from './functionality.state';
import { LoadUser, UserStateModel } from './user.model';
import { UserService } from './user.service';

@State<UserStateModel>({
  name: 'user',
  defaults: {
    loading: true
  },
  children: [FunctionalityState]
})
export class UserState {
  @Selector()
  static user(state: UserStateModel) {
    return state;
  }

  @Selector()
  static availableMunicipalities(state: UserStateModel) {
    return state.availableMunicipalities;
  }

  constructor(private userService: UserService) {}

  @Action(LoadUser)
  loadUser({ patchState }: StateContext<UserStateModel>) {
    return this.userService.loadUser().pipe(
      tap((user: UserStateModel) => {
        patchState({ ...user, loading: false });
      })
    );
  }
}
